import { z } from "zod"

const safeString = z.string().optional().catch(undefined)
const safeBoolean = z.boolean().optional().catch(undefined)

export const SupernovaConfigStorybook = z.object({
  designSystemId: safeString,
  sourceId: safeString,
  brandId: safeString,
  name: safeString,
  from: safeString,
  publicAccess: safeBoolean,
})

export const SupernovaConfigAnalyze = z.object({
  repoId: safeString,
  repoName: safeString,
  packages: z.array(z.string()).optional().catch(undefined),
  excludedPackages: z.array(z.string()).optional().catch(undefined),
})

export const SupernovaConfig = z
  .object({
    designSystemId: safeString,
    analyze: SupernovaConfigAnalyze.optional().catch(undefined),
    storybook: SupernovaConfigStorybook.optional().catch(undefined),
  })
  .catch({})

export type SupernovaConfigAnalyze = z.infer<typeof SupernovaConfigAnalyze>
export type SupernovaConfigStorybook = z.infer<typeof SupernovaConfigStorybook>
export type SupernovaConfig = z.infer<typeof SupernovaConfig>
